import React, { useState, useEffect, useMemo, memo } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import {
  InputGroup,
  Button,
  FormControl,
  Col,
  Accordion,
  Row,
  Card,
  Spinner,
} from "react-bootstrap";
import _ from "lodash";
import ApiPublicPromoCodeService from "../../../../core/api/api.publicPromoCode";
import apiAmusementService from "../../../../core/api/api.amusementService";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { FormProvider, useForm, Controller } from "react-hook-form";

import { useLocation, useNavigate } from "react-router-dom";
import DataGridUsedPromoCodeByUser from "./DataGridUsedPromoCodeByUser";
import { TextField } from "@mui/material";
import Select from "react-select";
import { tools } from "../../../../core/utils/tools";
import ShamsiDatePicker from "../../_Components/ShamsiDatePicker";

const Index = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const [listData, setListData] = useState({});
  const [checkBoxList2, setCheckBoxList2] = useState([]);
  //const [checkBoxList, setcheckBoxList] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [groupByAmuzmentService, setgroupByAmuzmentService] = useState([]);
  const [allAmusementServiceList, setAllAmusementServiceList] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
  } = useForm({});

  const methods = {
    register,
    handleSubmit,
    control,
    formState: { errors },
    getValues,
    setValue,
    watch,
  };

  useEffect(() => {
    (async () => {
      try {
        const data = await ApiPublicPromoCodeService.getAllUsedPromoCodeByUser({
          pageSize: searchParams.get("pageSize"),
          pageNumber: searchParams.get("pageNumber"),
          globalSearch: searchParams.get("globalSearch"),
          fromCreatedDate: searchParams.get("fromCreatedDate"),
          toCreatedDate: searchParams.get("toCreatedDate"),
          promoCode: searchParams.get("promoCode"),
          amusmentServiceId: searchParams.get("amusmentServiceId"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const apiData = await apiAmusementService.getAllAmusementServices();
        setAllAmusementServiceList(apiData);

        const formInputs = [
          { name: "globalSearch", type: "text", defaultValue: "" },
          { name: "promoCode", type: "text", defaultValue: "" },
          { name: "pageSize", type: "number", defaultValue: "" },
          { name: "pageNumber", type: "number", defaultValue: "" },
          { name: "fromCreatedDate", type: "datePicker", defaultValue: "" },
          { name: "toCreatedDate", type: "datePicker", defaultValue: "" },
          {
            name: "amusmentServiceId",
            type: "multiSelect",
            defaultValue: "",
            data: apiData,
          },
        ];

        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
  }, [refresh]);

  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);
  };

  const onSubmit = async (data) => {
    data.amusmentServiceId = data?.amusmentServiceId?.value;
    if (data.fromCreatedDate && typeof data.fromCreatedDate === "object") {
      data.fromCreatedDate = tools.DateFormat(data.fromCreatedDate);
    }
    if (data.toCreatedDate && typeof data.toCreatedDate === "object") {
      data.toCreatedDate = tools.DateFormat(data.toCreatedDate);
    }

    tools.setPageNumber(data, searchParams, setValue);

    const apiData =
      await ApiPublicPromoCodeService.getAllUsedPromoCodeByUser(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    var queryString = tools.createQueryStringFromFromData(
      _.omit(data, ["totalPages", "totalCount"])
    );
    navigate(`/usedPromoCodeByUser?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              گزارش فروش کد تخفیف
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست کدهای تخفیف فروش رفته
            </span>
          </h3>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header
                      as={Card.Header}
                      variant="link"
                      eventKey="0"
                    >
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">
                        جستجو پیشرفته
                      </Card.Title>
                    </Accordion.Header>
                    <Accordion.Body eventKey="0">
                      <Card.Body className="pt-0">
                        <Row>
                          <Col
                            xs="12"
                            sm="6"
                            xl="3"
                            className="tb-reponsive px-2"
                          >
                            <Controller
                              name="promoCode"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="کد تخفیف"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onChange={onChange}
                                ></TextField>
                              )}
                            />
                          </Col>
                          <Col
                            xs="12"
                            sm="6"
                            xl="3"
                            className="tb-reponsive px-2 mt-5"
                          >
                            <Controller
                              name="amusmentServiceId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  inputId="react-select-multiple"
                                  TextFieldProps={{
                                    label: "Countries",
                                    InputLabelProps: {
                                      htmlFor: "react-select-multiple",
                                      shrink: true,
                                    },
                                    placeholder: "Select multiple countries",
                                  }}
                                  options={allAmusementServiceList?.map(
                                    (item) => ({
                                      value: item.id,
                                      label: item.name,
                                    })
                                  )}
                                  value={value || ""}
                                  onChange={onChange}
                                  label="انتخاب تفریح"
                                  placeholder="انتخاب تفریح"
                                />
                              )}
                            />
                          </Col>

                          <Col
                            xs="12"
                            sm="6"
                            xl="3"
                            className="tb-reponsive px-2 mt-5"
                          >
                            <Controller
                              name="fromCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={onChange}
                                  placeholder="از تاریخ"
                                />
                              )}
                            />
                          </Col>
                          <Col
                            xs="12"
                            sm="6"
                            xl="3"
                            className="tb-reponsive px-2 mt-5"
                          >
                            <Controller
                              name="toCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={onChange}
                                  placeholder="تا تاریخ"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className="tb-reponsive mt-3 px-2">
                            <Button
                              variant="success"
                              type="submit"
                              disabled={isSubmitting}
                            >
                              {isSubmitting && (
                                <Spinner
                                  animation="border"
                                  variant="warning"
                                  size="sm"
                                />
                              )}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() =>
                                tools.handleResetAdvanceSearchBox(watch, reset)
                              }
                              className="ml-5"
                            >
                              {isSubmitting && (
                                <Spinner
                                  animation="border"
                                  variant="warning"
                                  size="sm"
                                />
                              )}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <FormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button
                    variant="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner animation="border" variant="warning" size="sm" />
                    ) : (
                      <SearchIcon />
                    )}
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                {
                  <DataGridUsedPromoCodeByUser
                    data={listData}
                    setCheckBoxList2={setCheckBoxList2}
                    callBack={callBackJustForRunUseEffect}
                  />
                }
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Index;
